import * as React from "react";

export function isRequired(value: any, displayName: string) {
  if (value === "" || value == null) {
    return `${displayName} is required.`;
  }
  return undefined;
}

export function isNumber(value: any, displayName: string) {
  const val = parseFloat(value);
  if (isNaN(val)) {
    return `${displayName} must be a number.`;
  }
  return undefined;
}

export function validateValueIsInRange(min?: number, max?: number) {
  return function (value: any, displayName: string) {

    function getErrorMessage() {
      if (min != null && max != null) {
        return `${displayName} must between ${min} and ${max}.`;
      }
      if (min == null && max != null) {
        return `${displayName} must less than ${max}.`;
      }
      if (min != null && max == null) {
        return `${displayName} must greater than ${min}.`;
      }
      if (min == null && max == null) {
        return `${displayName} must a number.`;
      }
      throw "Unreachable";
    }

    const val = parseFloat(value);
    if (isNaN(val)) {
      return getErrorMessage();
    }
    else {
      if (min != null && val < min) {
        return getErrorMessage();
      }
      else if (max != null && val > max) {
        return getErrorMessage();
      }
    }
    return undefined;
  }
}

export interface ValueDesc<TObj> {
  display: string;
  label?: string;
  valueName: keyof TObj & (string);
  validators?: ((val: any, display: string) => string)[];
  filter?: (val: string) => string;
  defaultValue?: any;
  inputProps?: any;
  type?: 'textarea' | 'input' | { type: 'select', options: any[] }
}

export function getDefault<TObj>(config: Config<TObj>) {
  var obj: Partial<TObj> = {};
  for (var key in config) {
    var desc: ValueDesc<TObj> = config[key];
    obj[key] = desc.defaultValue === undefined ? '' : desc.defaultValue;
  }
  return obj;
}

export function getErrors<TObj>(obj: TObj, config: Config<TObj>) {
  var errors: Partial<Record<keyof TObj, string[]>> = {};
  for (var key in config) {
    var desc = config[key];
    const val = obj[desc.valueName];
    errors[desc.valueName] = [];
    if (desc.validators) {
      for (var validator of desc.validators) {
        var error = validator(val, desc.display);
        if (error != null) {
          errors[desc.valueName].push(error);
        }
      }
    }
  }
  return errors;
}

export function getFirstError<TObj>(obj: Partial<TObj>, config: Config<TObj>) {
  var errors: Partial<Record<keyof TObj, string[]>> = {};
  for (var key in config) {
    var desc = config[key];
    const val = obj[desc.valueName];
    errors[desc.valueName] = [];
    if (desc.validators) {
      for (var validator of desc.validators) {
        var error = validator(val, desc.display);
        if (error != null) {
          return error;
        }
      }
    }
  }
  return null;
}

interface InputFields {
  value: any;
  onChange: (e: { target: { name: string, value: any } }) => void;
  name: string;
}

export function generateAllInputsFields<TObj>(obj: Partial<TObj>, config: Config<TObj>, setState: (obj: TObj) => void) {
  var inputFields: Partial<Record<keyof TObj, InputFields>> = {};
  for (var key in config) {
    inputFields[key] = generateInputFields(obj, config[key], setState);
  }
  return inputFields;
}

export function generateInputFields<TObj>(obj: Partial<TObj>, valueDesc: ValueDesc<TObj>, setState: (obj: Partial<TObj>) => void): InputFields {
  var onChange: (e: { target: { name: string, value: any } }) => void = (e) => {
    const myObj = { ...obj };
    myObj[e.target.name] = e.target.value;
    setState(myObj);
  };
  return {
    value: obj[valueDesc.valueName],
    onChange: onChange,
    name: valueDesc.valueName
  }
}

export type Config<TObj> = Partial<Record<keyof TObj, ValueDesc<TObj>>>;


export function generateDeviceRow<TObj>(
  desc: ValueDesc<TObj>,
  obj: Partial<TObj>,
  setState: (newstate: Partial<TObj>) => void,
  disabled?: boolean,
  style?: React.CSSProperties) {
  var fields = generateInputFields(
    obj,
    desc,
    setState);
  function inputRow() {
    if (!desc.type || desc.type == 'input') {
      const defaultStyle = {
        backgroundColor: "white",
      };
      const rowStyle = style != null ? { ...defaultStyle, ...style } : defaultStyle;
      return <input
        {...fields}
        type="text"
        {...desc.inputProps}
        style={rowStyle}
        disabled={disabled}
      />
    } else if (desc.type == 'textarea') {

    } else if (typeof (desc.type) == 'object') {
      if (desc.type.type === 'select') {
        return <select {...fields}
          disabled={disabled} >
          {
            desc.type.options.map(o =>
              <option value={o} > {o} </option>)
          }
        </select>
      }
    }
  }
  return <React.Fragment>
    <tr>
      <td className="custom-support-label" >
        <span>{desc.display} </span>
      </td>
      <td className="custom_device_text" >
        {
          inputRow()
        }
      </td>
    </tr>
  </React.Fragment>
}